export const double_column = `.de BL
.IP (bu
..

.TL 
Title
.AU 
Joe Don, heading
.AI
School
.ND 
16/09/2020
.AB
Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non nisi est sit amet facilisis magna etiam tempor. Blandit turpis cursus in hac habitasse platea dictumst. Proin sed libero enim sed faucibus. Odio euismod lacinia at quis risus. Suspendisse potenti nullam ac tortor vitae purus faucibus. Ornare aenean euismod elementum nisi quis. Turpis egestas pretium aenean pharetra magna. Velit laoreet id donec ultrices. Pharetra sit amet aliquam id. Amet facilisis magna etiam tempor orci eu lobortis elementum nibh. Est velit egestas dui id ornare. Turpis egestas pretium aenean pharetra magna ac.
.AE
.2C
.SH
Introduction
.LP
Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non nisi est sit amet facilisis magna etiam tempor. Blandit turpis cursus in hac habitasse platea dictumst. Proin sed libero enim sed faucibus. Odio euismod lacinia at quis risus. Suspendisse potenti nullam ac tortor vitae purus faucibus. Ornare aenean euismod elementum nisi quis. Turpis egestas pretium aenean pharetra magna. Velit laoreet id donec ultrices. Pharetra sit amet aliquam id. Amet facilisis magna etiam tempor orci eu lobortis elementum nibh. Est velit egestas dui id ornare. Turpis egestas pretium aenean pharetra magna ac..PP

.NH 1
Lorem Ipsum
.PP
Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non nisi est sit amet facilisis magna etiam tempor. Blandit turpis cursus in hac habitasse platea dictumst. Proin sed libero enim sed faucibus. Odio euismod lacinia at quis risus. Suspendisse potenti nullam ac tortor vitae purus faucibus. Ornare aenean euismod elementum nisi quis. Turpis egestas pretium aenean pharetra magna. Velit laoreet id donec ultrices. Pharetra sit amet aliquam id. Amet facilisis magna etiam tempor orci eu lobortis elementum nibh. Est velit egestas dui id ornare. Turpis egestas pretium aenean pharetra magna ac.
.NH 2
Heading 1
.QP
Blandit turpis cursus in hac habitasse platea dictumst. Proin sed libero enim sed faucibus. Odio euismod lacinia at quis risus. Suspendisse potenti nullam ac tortor vitae purus faucibus. Ornare aenean euismod elementum nisi quis. Turpis egestas pretium aenean pharetra magna.
.IP 1
Velit laoreet id donec ultrices. Pharetra sit amet aliquam id.
.IP 2
Velit laoreet id donec ultrices. Pharetra sit amet aliquam id.
.NH 2
Procedure
.PP
Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non nisi est sit amet facilisis magna etiam tempor. Blandit turpis cursus in hac habitasse platea dictumst. Proin sed libero enim sed faucibus. Odio euismod lacinia at quis risus. Suspendisse potenti nullam ac tortor vitae purus faucibus. Ornare aenean euismod elementum nisi quis. Turpis egestas pretium aenean pharetra magna. Velit laoreet id donec ultrices. Pharetra sit amet aliquam id. Amet facilisis magna etiam tempor orci eu lobortis elementum nibh. Est velit egestas dui id ornare. Turpis egestas pretium aenean pharetra magna ac.


.NH 2
Input and Output parameters
.PP
Input parameters
.QP
.BX "test: String"
.BX "test: String"
.PP
Output parameters
.QP
.BX "test: String"
.BX "statusCode: 404"

.NH 1
Heading 1
.PP
Amet facilisis magna etiam tempor orci eu lobortis elementum nibh. Est velit egestas dui id ornare. Turpis egestas pretium aenean pharetra magna ac..NH 2
.QP
Amet facilisis magna etiam tempor orci eu lobortis elementum nibh. Est velit egestas dui id ornare. Turpis egestas pretium aenean pharetra magna ac.
?
.NH 2
Procedure
.PP
Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non nisi est sit amet facilisis magna etiam tempor. Blandit turpis cursus in hac habitasse platea dictumst. Proin sed libero enim sed faucibus. Odio euismod lacinia at quis risus. Suspendisse potenti nullam ac tortor vitae purus faucibus. Ornare aenean euismod elementum nisi quis. Turpis egestas pretium aenean pharetra magna. Velit laoreet id donec ultrices. Pharetra sit amet aliquam id. Amet facilisis magna etiam tempor orci eu lobortis elementum nibh. Est velit egestas dui id ornare. Turpis egestas pretium aenean pharetra magna ac.


Amet facilisis magna etiam tempor orci eu lobortis elementum nibh. Est velit egestas dui id ornare. Turpis egestas pretium aenean pharetra magna ac.

.NH 2
Input and Output parameters
.PP
Input parameters
.QP
.BX "email: String"
.BX "password: String"
.PP
Output parameters
.QP
.BX "jwt: String"
.BX "statusCode: 200"

.NH 1
Heading 1
.PP
Amet facilisis magna etiam tempor orci eu lobortis elementum nibh. Est velit egestas dui id ornare. Turpis egestas pretium aenean pharetra magna ac..NH 2

.PP
Amet facilisis magna etiam tempor orci eu lobortis elementum nibh. Est velit egestas dui id ornare. Turpis egestas pretium aenean pharetra magna ac.
.IP
Amet facilisis magna etiam tempor orci eu lobortis elementum nibh. Est velit egestas dui id ornare. Turpis egestas pretium aenean pharetra magna ac.
.Ip
Amet facilisis magna etiam tempor orci eu lobortis elementum nibh. Est velit egestas dui id ornare. Turpis egestas pretium aenean pharetra magna ac.
.IP
Amet facilisis magna etiam tempor orci eu lobortis elementum nibh. Est velit egestas dui id ornare. Turpis egestas pretium aenean pharetra magna ac.
.NH 2
Heading 1
.PP
Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non nisi est sit amet facilisis magna etiam tempor. Blandit turpis cursus in hac habitasse platea dictumst. Proin sed libero enim sed faucibus. Odio euismod lacinia at quis risus. Suspendisse potenti nullam ac tortor vitae purus faucibus. Ornare aenean euismod elementum nisi quis. Turpis egestas pretium aenean pharetra magna. Velit laoreet id donec ultrices. Pharetra sit amet aliquam id. Amet facilisis magna etiam tempor orci eu lobortis elementum nibh. Est velit egestas dui id ornare. Turpis egestas pretium aenean pharetra magna ac.


`;